export default __webpack_public_path__ + "static/media/ico_maximize_graphic.6d2f4e6a.svg";